var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "formRef",
      attrs: {
        model: _vm.form,
        "label-width": "100px",
        "label-position": _vm.getIsMobile ? "top" : "right",
      },
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "纳税识别号", prop: "kpsbnum" } },
        [
          _c("el-input", {
            attrs: { type: "text", placeholder: "请输入纳税识别号" },
            model: {
              value: _vm.form.kpsbnum,
              callback: function ($$v) {
                _vm.$set(_vm.form, "kpsbnum", $$v)
              },
              expression: "form.kpsbnum",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "公司地址", prop: "kpaddress" } },
        [
          _c("el-input", {
            attrs: { type: "text", placeholder: "请输入公司地址" },
            model: {
              value: _vm.form.kpaddress,
              callback: function ($$v) {
                _vm.$set(_vm.form, "kpaddress", $$v)
              },
              expression: "form.kpaddress",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "公司电话", prop: "tel" } },
        [
          _c("el-input", {
            attrs: { type: "text", placeholder: "请输入公司电话" },
            model: {
              value: _vm.form.tel,
              callback: function ($$v) {
                _vm.$set(_vm.form, "tel", _vm._n($$v))
              },
              expression: "form.tel",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "传真", prop: "max" } },
        [
          _c("el-input", {
            attrs: { type: "text", placeholder: "请输入传真号" },
            model: {
              value: _vm.form.max,
              callback: function ($$v) {
                _vm.$set(_vm.form, "max", _vm._n($$v))
              },
              expression: "form.max",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "开户银行", prop: "bank" } },
        [
          _c("el-input", {
            attrs: { type: "text", placeholder: "请输入开户银行" },
            model: {
              value: _vm.form.bank,
              callback: function ($$v) {
                _vm.$set(_vm.form, "bank", _vm._n($$v))
              },
              expression: "form.bank",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "银行账号", prop: "banknum" } },
        [
          _c("el-input", {
            attrs: { type: "text", placeholder: "请输入银行账号" },
            model: {
              value: _vm.form.banknum,
              callback: function ($$v) {
                _vm.$set(_vm.form, "banknum", _vm._n($$v))
              },
              expression: "form.banknum",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "备注", prop: "kpbz" } },
        [
          _c("el-input", {
            attrs: { type: "text", placeholder: "请输入备注" },
            model: {
              value: _vm.form.kpbz,
              callback: function ($$v) {
                _vm.$set(_vm.form, "kpbz", $$v)
              },
              expression: "form.kpbz",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }